import { useEffect, useState } from "react"
import { Link, useParams } from "react-router-dom"
import { api, ApiError } from "../../lib/api"
import type { Chamado as ChamadoTipo } from "../../types"
import { dataCurta } from "../../lib/format"
import { Card, Carregando, Erro } from "../ui"
import { Situacao } from "./situacao"

export default function Chamado() {
  const { id } = useParams<{ id: string }>()
  const [chamado, setChamado] = useState<ChamadoTipo | null>(null)
  const [erro, setErro] = useState<string | null>(null)

  useEffect(() => {
    api
      .get<{ chamado: ChamadoTipo }>(`/chamados/${id}`)
      .then((r) => setChamado(r.chamado))
      .catch((e: unknown) => setErro(e instanceof ApiError ? e.message : "Não foi possível abrir o chamado."))
  }, [id])

  if (erro) {
    return (
      <div className="space-y-4">
        <Erro mensagem={erro} />
        <Link to="/suporte" className="text-sm font-semibold text-navy-800 underline">
          Voltar para o suporte
        </Link>
      </div>
    )
  }

  if (!chamado) return <Carregando />

  return (
    <div className="space-y-6">
      <div className="revela">
        <Link to="/suporte" className="text-sm font-semibold text-navy-800 underline underline-offset-4">
          ← Suporte
        </Link>
        <div className="mt-3 flex flex-wrap items-start justify-between gap-3">
          <h1 className="font-display text-3xl leading-tight text-navy-900">{chamado.assunto}</h1>
          <Situacao status={chamado.status} />
        </div>
        <p className="mt-2 text-xs text-slate-500">Aberto em {dataCurta(chamado.created_at)}</p>
      </div>

      <Card>
        <p className="text-xs font-semibold uppercase tracking-[0.16em] text-navy-600">Sua mensagem</p>
        <p className="mt-2 whitespace-pre-line text-sm leading-relaxed text-navy-900">{chamado.mensagem}</p>
      </Card>

      {chamado.resposta ? (
        <Card destaque>
          <p className="text-xs font-semibold uppercase tracking-[0.16em] text-navy-700">
            Nossa resposta
            {chamado.respondido_em ? ` · ${dataCurta(chamado.respondido_em)}` : ""}
          </p>
          <p className="mt-2 whitespace-pre-line text-sm leading-relaxed text-navy-900">{chamado.resposta}</p>
        </Card>
      ) : (
        <Card>
          <p className="text-center text-sm text-slate-600">Aguardando resposta.</p>
          <p className="mt-1 text-center text-xs text-slate-500">
            Assim que respondermos, você recebe um e-mail e a resposta aparece aqui.
          </p>
        </Card>
      )}
    </div>
  )
}
